import script from "./SmallFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallFooter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFooter});
